import { app, Utilities } from 'core';
import { selectors as userSelectors } from 'core/use-cases/user';
import { LoaderFullScreen } from 'ui/components';

const Loader = ({ isFromSearch = false }: any) => {
  const { isLoading, message } = app.hooks.useApp('loader');
  const { status: statusRequest } = userSelectors.useUserSelector();

  if (isLoading || statusRequest === Utilities.STATUS.RUNNING) {
    return <LoaderFullScreen isFromSearch={isFromSearch} message={message || ''} />;
  }
  // return <LoaderFullScreen isFromSearch={isFromSearch} message={message || ''} />;
  return null;
};

export default Loader;
